const InvoiceFormItem = ({data, label, show, alwaysUseMobileStyling, className, labelClassName, valueClassName, children}) => {
    const isMobile = data.isMobile || alwaysUseMobileStyling;
    const valueEmphasisClassName = labelClassName?.includes('font-weight-bold') ? 'font-weight-bold font-weight-bolder' : '';

    // Keep one shared component for both breakpoints, but switch the desktop row to CSS grid
    // so labels and values line up consistently across the invoice form.
    const layoutClassName = isMobile ? 'invoice-form-item--mobile' : 'invoice-form-item--desktop';
    const wrapperClassName = ['invoice-form-item', layoutClassName, className, isMobile ? 'flex-column mb-3' : '']
        .filter(Boolean)
        .join(' ');

    
    return (
        <div className={wrapperClassName} style={{ display: show ? (isMobile ? 'flex' : 'grid') : 'none' }}>
            <div className={`invoice-form-item__label ${labelClassName} ${isMobile ? 'text-primary mb-1' : ''}`}>
                { label }{ isMobile ? '' : ':' }
            </div>
            <div className={`invoice-form-item__value invoice-value ${valueEmphasisClassName} ${valueClassName || ''} ${isMobile ? '' : 'align-content-end'}`}>
                { children }
            </div>
        </div>
    );
};

export default InvoiceFormItem;
